import { useFormik } from "formik";
import * as Yup from 'yup';
import dayjs from "dayjs";
import React, { useEffect, useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Autocomplete, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useNavigate } from 'react-router-dom';
import { getAllCustomersAuto } from "../../../lib/api-customer";
import { getPrint, getDyeById, updateDye, createDye, getAutoCertificateNo, deleteDyeDescription, getDyePDF } from "../../../lib/api-dye";
import { Select, MenuItem, InputLabel, FormHelperText } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import LoadingSpinner from "../../../components/common/LoadingSpinner";
import { Dialog, DialogActions, DialogTitle } from '@mui/material';
import { APP_BASE_PATH } from "../../../lib/api-base-paths";
import CustomSnackbar from "../../../components/common/CustomSnackbar";
import { layoutPrintFormFields } from "../../../utils/printFieldLayout";
import { getUnpaidBillsByCustomer } from '../../../lib/api-bill';

const CreateDyes = ({ dyeId, isEdit }) => {
  const [cust, setCust] = useState([]);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [color, setColor] = useState("")
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dye, setDye] = useState(false)
  const [rows, setRows] = useState([]);
  const [unpaidBills, setUnpaidBills] = useState([]);
  const [unpaidDialogOpen, setUnpaidDialogOpen] = useState(false);
  const thStyle = { padding: '8px 12px', textAlign: 'left', fontWeight: 600 };
  const tdStyle = { padding: '7px 12px', borderBottom: '1px solid #e0e0e0' };
  const [formikValues, setFormikValues] = useState({
    Description: '',
    Qty: '',
    Weight: '',
    Accepted: '',

    Rejected: '',
    Remarks: '',
    customRemarks: ''
  });
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [idCounter, setIdCounter] = useState(1);
  const handlePDFModalClose = () => {
    setPdfData(null)
    setOpenPDFModal(false)
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormikValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };


  const handleAddRow = () => {

    if (!formikValues.Description || !formikValues.Qty || !formikValues.Weight || !formikValues.Accepted || !formikValues.Rejected || !formikValues.Remarks) {
      alert("Please fill in all required fields.");
      return;
    }

    const newRow = { id: idCounter, srNo: idCounter, ...formikValues };
    setIdCounter(idCounter + 1);

    if (rows.length > 0) {
      const maxSrNo = Math.max(...rows.map(row => row.srNo));
      newRow.srNo = maxSrNo + 1;
    } else {
      newRow.srNo = 1;
    }

    newRow.id = newRow.srNo;

    newRow.Remarks = formikValues.Remarks === 'Other' ? formikValues.customRemarks : formikValues.Remarks;

    setRows(prevRows => [...prevRows, newRow]);

    setFormikValues({
      Description: '',
      Qty: '',
      Weight: '',
      Accepted: '',
      Rejected: '',
      Remarks: '',
      customRemarks: ''
    });
  };




  const handleDelete = (id) => {
    deleteDyeDescription(id)
      .then(response => {
        console.log(response.data);
        setRows(prevRows => prevRows.filter(row => row.id !== id));
      })
      .catch(error => {
        console.error('Error deleting row:', error); // Handle error
      });
  };




  const initalValues = {
  Cert_Date: dayjs().format('YYYY-MM-DD'),
  Certificate_No: '',
  Cust_Name: { value: '', label: '' },
  Referance_Id: '',
  Test_Spec: '',

  // Default values from dyeFieldOptions
  Acceptance_Std: 'ASTM E-165', 
  Applicable_Spec: 'ASTM E-165',
  Scope_Exam: 'All Surface Area',
  Method: 'Visible',
  Penetrant: 'Solvent Removable',
  Penetrant_time: '10 min',
  Batch_No1: '',
  Examination: 'Lifting Lug Plate Welding',
  Developer: 'Dyeglo',
  Developer_time: '10 min',
  Application: 'Spray / Brush',
  Cleaner_Type: 'Solvent Cleaner',
  Black_Light: 'more than 1000µW/cm2/ 1076 lux',
  Batch_No2: '',
  Batch_NoExam: '',
  UV_No: '',

  Witness_By: '',
  technician: '',
  Location: '',
  designation: 'ASNT LEVEL II - UT.MT.PT',

  Procedure_No: 'SNDTS/NDT/PT/01',

  Developer_Exp: '',
  Cleaner_Exp: '',
  Light_Equipment: 'Visible  Light',
  Penetrant_Exp: '',
  Post_Cleaning: '',
};

  const navigate = useNavigate();
  const handleBack = () => {
    navigate('/Dye');
  }

  const columns = [
    { field: 'srNo', headerName: 'Sr.No.', flex: 1 },
    { field: 'Description', headerName: 'Part Description', flex: 1 },
    { field: 'Qty', headerName: 'Qty', flex: 1 },
    { field: 'Weight', headerName: 'Weight', flex: 1 },
    { field: 'Accepted', headerName: 'Accepted', flex: 1 },
    { field: 'Rejected', headerName: 'Rejected', flex: 1 },
    { field: 'Remarks', headerName: 'Remarks', flex: 1 },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => (
        <div>
          <IconButton onClick={() => handleDelete(params.row.id)}>
            <DeleteIcon sx={{ color: 'red' }} />
          </IconButton>
        </div>

      ),
    },
  ];


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllCustomersAuto();
        setCust(() => {
          const customerOp = response.map((row) => { return { value: row.Cust_Id, label: row.Cust_Name } });
          return customerOp;
        });
      } catch (error) {
        console.error("Error fetching customers:", error);
      }
    };
    fetchData();
  }, [])


  useEffect(() => {

  // Generate certificate number ONLY when creating a NEW Dye certificate.
  // Never generate a new number while editing an existing certificate.
  if (isEdit) {
    return;
  }

  const fetchCertificateNo = async () => {
    try {
      const getCertificateNo = await getAutoCertificateNo();
      const maxNumber = getCertificateNo.data.nextCertificateNo;

      formik.setFieldValue('Certificate_No', maxNumber);

    } catch (error) {
      console.error("Error fetching Dye certificate number:", error);
    }
  };

  fetchCertificateNo();

}, [isEdit]);

  const handlePrintforedit = async () => {
    try {
      setLoading(true);
      const getPDF = await getDyePDF(dyeId);
      setOpenPDFModal(true);
      const filepath = `${getPDF.data.returnpath}?v=${Date.now()}`;
      setPdfData(`${filepath}?t=${Date.now()}`);

    } catch (error) {
      console.error("Error while printing:", error);
    } finally {
      setLoading(false);

    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const getDyeData = await getDyeById(dyeId);
        setDye(true);

        const dyeData = getDyeData.data.dye;
        const CustNew = cust.filter((item) => item.value == dyeData.Cust_Name)[0];
        const parseDate = (dateString) => {
  if (!dateString) return null;

  // Already in YYYY-MM-DD format
  if (dateString.includes("-")) {
    return dateString;
  }

  // Convert DD/MM/YYYY to YYYY-MM-DD
  const parts = dateString.split("/");

  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  return null;
};
        const sortedData = {
          Cert_Date: parseDate(dyeData.Cert_Date),
          Cust_Name: CustNew,
          Certificate_No: dyeData.Certificate_No,
          Referance_Id: dyeData.Referance_Id,
          Test_Spec: dyeData.Test_Spec,
          Applicable_Spec: dyeData.Applicable_Spec,
          Acceptance_Std: dyeData.Acceptance_Std,
          Scope_Exam: dyeData.Scope_Exam,
          Method: dyeData.Method,
          Penetrant: dyeData.Penetrant,
          Penetrant_time: dyeData.Penetrant_time,
          Batch_NoExam: dyeData.Batch_NoExam,
          Examination: dyeData.Examination,
          Developer: dyeData.Developer,
          Developer_time: dyeData.Developer_time,
          Application: dyeData.Application,
          Cleaner_Type: dyeData.Cleaner_Type,
          Black_Light: dyeData.Black_Light,
          Batch_No1: dyeData.Batch_No1,
          Batch_No2: dyeData.Batch_No2,
          UV_No: dyeData.UV_No,
          Witness_By: dyeData.Witness_By,
          technician: dyeData.technician,
          Location: dyeData.Location,
          designation: dyeData.designation,
          Procedure_No: dyeData.Procedure_No || '',
          Developer_Exp: parseDate(dyeData.Developer_Exp) || null,   // reuse existing parseDate
          Cleaner_Exp: parseDate(dyeData.Cleaner_Exp) || null,
          Penetrant_Exp: parseDate(dyeData.Penetrant_Exp) || null,
          Light_Equipment: dyeData.Light_Equipment || '',
          Post_Cleaning: dyeData.Post_Cleaning || '',
        };
        formik.setValues(sortedData);

        const sortedRows = getDyeData.data.rows.map((row, index) => ({
          id: row.id,
          srNo: index + 1,
          ...row
        }));
        setRows(sortedRows);
      } catch (error) {
        console.log("Error in Fetching Data", error);
      } finally {
        setLoading(false);
      }
    };

    if (isEdit) {
      fetchData();
    }
  }, [isEdit, dyeId, cust]);






  const formik = useFormik({
    initialValues: initalValues,
    validationSchema: Yup.object().shape({
      Cert_Date: Yup.date().required(),
      Certificate_No: Yup.number().integer().notRequired(),
      Test_Spec: Yup.string().notRequired(),
      Cust_Name: Yup.object().notRequired(),
      Referance_Id: Yup.string().required(),
      Acceptance_Std: Yup.string().notRequired(),
      Applicable_Spec: Yup.string().notRequired(),
      Scope_Exam: Yup.string().notRequired(),
      Method: Yup.string().notRequired('Method is required'),
      Penetrant: Yup.string().notRequired(),
      Penetrant_time: Yup.string().notRequired(),
      Batch_No1: Yup.string().notRequired(),
      Examination: Yup.string().notRequired(),
      Developer: Yup.string().notRequired(),
      Developer_time: Yup.string().notRequired(),
      Application: Yup.string().notRequired(),
      Cleaner_Type: Yup.string().notRequired(),
      Black_Light: Yup.string().notRequired(),
      Batch_No2: Yup.string().notRequired(),
      Batch_NoExam: Yup.string().notRequired(),
      UV_No: Yup.string().notRequired(),
      Witness_By: Yup.string().notRequired(),
      technician: Yup.string().notRequired("xxxx"),
      Location: Yup.string().notRequired("yyyyyyyyyy"),
      designation: Yup.string().notRequired(),
      Procedure_No: Yup.string().notRequired(),
      Developer_Exp: Yup.string().notRequired(),
      Cleaner_Exp: Yup.string().notRequired(),
      Light_Equipment: Yup.string().notRequired(),
      Penetrant_Exp: Yup.string().notRequired(),
      Post_Cleaning: Yup.string().notRequired(),

    }),
    onSubmit: async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
      try {
        setLoading(true);
        let response = {};
        if (rows.length == 0) {
          setConfirmationMessage("Somthing Went Wrong!");
          setIsConfirmationOpen(true);
          setColor('error')
        }
        values.rows = rows;

        if (isEdit) {
          response = await updateDye(dyeId, values);
          setConfirmationMessage("Dye Updated successfully");
          setIsConfirmationOpen(true);
        } else {
         response = await createDye(values);
console.log(response)

if (response.status == 200) {
  console.log(response);

  setConfirmationMessage(response.data);
  setIsConfirmationOpen(true);
  setColor('green');
  setDye(true);

  // DO NOT reset the form here.
  // Keep exactly the values that were just saved.
  // resetForm();

  // Keep rows visible too until printing
  // setRows([]);
} else {
            setConfirmationMessage("Somthing Went Wrong!");
            setIsConfirmationOpen(true);
            setColor('error')
          }



        }
      } catch (error) {
        setStatus({ success: false });
        setErrors({ submit: error.response.data.message });
        setSubmitting(false);
      } finally {
        setLoading(false);
      }
    }

  });

  const dyePrintLeft = [
    { name: 'Examination', label: 'Examination Stage' },
    { name: 'Scope_Exam', label: 'Scope of Examination' },
    { name: 'Location', label: 'Location' },
    { name: 'Acceptance_Std', label: 'Acceptance Standard' },
    { name: 'Applicable_Spec', label: 'Specification' },
    { name: 'Procedure_No', label: 'Procedure No' },
    { name: 'Method', label: 'Technique' },
    { name: 'Penetrant', label: 'Penetrant' },
    { name: 'Application', label: 'Penetrant Application', reactKey: 'Application-pen' },
    { name: 'Penetrant_time', label: 'Penetrant Dwell Time' },
    { name: 'Batch_No1', label: 'Batch No' },
    { name: 'Penetrant_Exp', label: 'Penetrant Exp Date', type: 'date' },
  ];

  const dyePrintRight = [
    { name: 'Developer', label: 'Developer' },
    { name: 'Application', label: 'Developer Application', reactKey: 'Application-dev' },
    { name: 'Developer_time', label: 'Developer Time' },
    { name: 'Batch_No2', label: 'Batch No' },
    { name: 'Developer_Exp', label: 'Developer Exp Date', type: 'date' },
    { name: 'Cleaner_Type', label: 'Cleaner' },
    { name: 'Batch_NoExam', label: 'Batch No' },
    { name: 'Cleaner_Exp', label: 'Cleaner Exp Date', type: 'date' },
    { name: 'Light_Equipment', label: 'Light Equipment' },
    { name: 'Black_Light', label: 'Light Intensity' },
    { name: 'UV_No', label: 'Equipment Serial No' },
    { name: 'Post_Cleaning', label: 'Post Cleaning Done' },
  ];

  const dyeFieldOptions = {
    Examination: ['Lifting Lug Plate Welding'],
    Scope_Exam: ['All Surface Area'],
    Acceptance_Std: ['ASTM E-165'],
    Applicable_Spec: ['ASTM E-165'],
    Procedure_No: ['SNDTS/NDT/PT/01'],
    Method: ['Visible'],
    Penetrant: ['Solvent Removable'],
    Application: ['Spray / Brush'],
    Penetrant_time: ['10 min', '15 min', '20 min', '30 min'],
    Batch_No1: [],
    Developer: ['Dyeglo'],
    Developer_time: ['10 min', '15 min'],
    Batch_No2: [],
    Cleaner_Type: ['Solvent Cleaner', 'Water'],
    Batch_NoExam: [],
    Light_Equipment: [],
    Black_Light: [],
    UV_No: [],
  };

  const renderDyePrintField = (field) => {
    const key = field.reactKey || field.name;
    if (field.type === 'date') {
      return (
        <LocalizationProvider key={key} dateAdapter={AdapterDayjs}>
          <DatePicker
            label={field.label}
            format="DD/MM/YYYY"
            value={formik.values[field.name] ? dayjs(formik.values[field.name]) : null}
            onChange={(date) => formik.setFieldValue(field.name, date ? dayjs(date).format('YYYY-MM-DD') : null)}
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                onBlur: formik.handleBlur,
                error: formik.errors[field.name] && formik.touched[field.name],
                helperText: formik.touched[field.name] ? formik.errors[field.name] : '',
              },
            }}
          />
        </LocalizationProvider>
      );
    }
    const options = dyeFieldOptions[field.name] || [];
    return (
      <Autocomplete
        key={key}
        freeSolo
        options={options}
        value={formik.values[field.name] ?? ''}
        onChange={(event, newValue) => formik.setFieldValue(field.name, newValue ?? '')}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') formik.setFieldValue(field.name, newInputValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            label={field.label}
            name={field.name}
            variant="outlined"
            onBlur={formik.handleBlur}
            error={formik.errors[field.name] && formik.touched[field.name]}
            helperText={formik.touched[field.name] ? formik.errors[field.name] : ''}
          />
        )}
      />
    );
  };

  const handlep = () => {
    if (dyeId) {
      handlePrintforedit()
    } else {
      handlePrint()
    }
  }


  const handlePrint = async () => {

    try {
      setLoading(true)
      const response = await getPrint();

      setOpenPDFModal(true);
      const filepath = `${response.returnpath}?v=${Date.now()}`;

      setPdfData(`${filepath}?t=${Date.now()}`);
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false)
    }

  }

  return (

    <div>
      {loading && <LoadingSpinner />}
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: "0.5rem" }}>
          <FormControl style={{ width: "180px" }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                name="Cert_Date"
                format="DD/MM/YYYY"
                label="Date"
                errors={formik.errors}
                value={formik.values.Cert_Date ? dayjs(formik.values.Cert_Date) : null}
                // onChange={(date) => {formik.setFieldValue('Cert_Date', date);}}
               onChange={(date) => {
  formik.setFieldValue(
    "Cert_Date",
    date ? dayjs(date).format('YYYY-MM-DD') : null
  );
}} />
            </LocalizationProvider>
          </FormControl>
          <TextField id="outlined-basic" style={{ width: "39vw" }} label="Certificate No." name='Certificate_No' variant="outlined" error={formik.errors.Certificate_No && formik.touched.Certificate_No}
            helperText={formik.touched.Certificate_No ? formik.errors.Certificate_No : ''}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.Certificate_No} />
        </div>
        <div>
          {/* <Autocomplete
            options={cust}
            getOptionLabel={(option) => option.label}
            onChange={(event, value) => formik.setFieldValue('Cust_Name', value || null)}
            value={formik.values.Cust_Name}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: "50vw" }}
                label="Customer Name"
                variant="outlined"
                name="Cust_Name"
                error={formik.errors.Cust_Name && formik.touched.Cust_Name}
                helperText={formik.touched.Cust_Name ? formik.errors.Cust_Name : ''}
                onBlur={formik.handleBlur}

              />
            )}
          /> */}
          <Autocomplete
            options={cust}
            getOptionLabel={(option) => option.label}
            onChange={async (event, value) => {
              formik.setFieldValue('Cust_Name', value || null);

              if (value) {
                try {
                  const res = await getUnpaidBillsByCustomer(value.value);
                  if (res.data && res.data.length > 0) {
                    setUnpaidBills(res.data);
                    setUnpaidDialogOpen(true);
                  }
                } catch (err) {
                  console.error('Error checking unpaid bills:', err);
                }
              }
            }}
            value={formik.values.Cust_Name}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={{ width: "50vw" }}
                label="Customer Name"
                variant="outlined"
                name="Cust_Name"
                error={formik.errors.Cust_Name && formik.touched.Cust_Name}
                helperText={formik.touched.Cust_Name ? formik.errors.Cust_Name : ''}
                onBlur={formik.handleBlur}
              />
            )}
          />




        </div>
        <div>
          <TextField
            style={{ width: "50vw" }}
            id="outlined-basic"
            label="Reference"
            name='Referance_Id'
            variant="outlined"
            error={formik.errors.Referance_Id && formik.touched.Referance_Id}
            helperText={formik.touched.Referance_Id ? formik.errors.Referance_Id : ''}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            value={formik.values.Referance_Id} />

        </div>
      </div>
      <br />
      <div >
        <div>
          <div style={{ display: 'flex', alignItems: 'center', columnGap: '1%' }}>



            <TextField
              id="outlined-basic"
              label="Part Description"
              name="Description"
              variant="outlined"
              style={{ width: '10vw' }}
              onChange={handleChange}
              value={formikValues.Description}
            />

            <TextField
              id="outlined-basic"
              label="Qty"
              name="Qty"
              variant="outlined"
              style={{ width: '10vw' }}
              onChange={handleChange}
              value={formikValues.Qty}
            />

            <TextField
              id="outlined-basic"
              label="Weight"
              name="Weight"
              variant="outlined"
              style={{ width: '10vw' }}
              onChange={handleChange}
              value={formikValues.Weight}
            />

            <TextField
              id="outlined-basic"
              label="Accepted"
              name="Accepted"
              variant="outlined"
              style={{ width: '10vw' }}
              onChange={handleChange}
              value={formikValues.Accepted}
            />

            <TextField
              id="outlined-basic"
              label="Rejected"
              name="Rejected"
              variant="outlined"
              style={{ width: '10vw' }}
              onChange={handleChange}
              value={formikValues.Rejected}
            />

            <FormControl>
              <InputLabel id="remarks-label">Remarks</InputLabel>
              <Select
                labelId="remarks-label"
                value={formikValues.Remarks}
                onChange={handleChange}
                label="Remarks"
                placeholder="Remarks"
                name="Remarks"
                style={{ width: '10vw' }}
              >
                <MenuItem value="No recordable Indication observed- Hence Accepted.">No recordable Indication observed- Hence Accepted.</MenuItem>
                <MenuItem value="Recordable indication observed hence not accepted.">Recordable indication observed hence not accepted.</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
                {formikValues.Remarks !== 'No recordable Indication observed- Hence Accepted.' &&
                  formikValues.Remarks !== 'Recordable indication observed hence not accepted.' &&
                  formikValues.Remarks !== 'Other' && (
                    <MenuItem value={formikValues.Remarks}>
                      {formikValues.Remarks}
                    </MenuItem>
                  )}
              </Select>
              {formikValues.Remarks === 'Other' && (
                <TextField
                  name="customRemarks"
                  value={formikValues.customRemarks}
                  onChange={handleChange}
                  label="Custom Remark"
                  variant="outlined"
                  style={{ marginTop: '20px', width: '10vw' }}
                />
              )}
            </FormControl>
            <Button onClick={handleAddRow} style={{ backgroundColor: "red", color: "white" }} variant="contained">Add</Button>


          </div>
          <div style={{ marginBlock: "20px" }}>
            <DataGrid
              autoHeight
              density="compact"
              rows={rows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
            />
          </div>

        </div>
      </div>



      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem", marginTop: "3vh" }}>
        {layoutPrintFormFields(dyePrintLeft, []).map(renderDyePrintField)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "2rem", marginTop: "2rem", marginBottom: "3vh" }}>
        {layoutPrintFormFields([], dyePrintRight).map(renderDyePrintField)}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "2rem", marginBottom: "3vh" }}>
        {/*  <TextField fullWidth label="Test Specification" name="Test_Spec" variant="outlined"
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Test_Spec} /> */}
        <TextField fullWidth label="Witness By" name="Witness_By" variant="outlined"
          error={formik.errors.Witness_By && formik.touched.Witness_By}
          helperText={formik.touched.Witness_By ? formik.errors.Witness_By : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.Witness_By} />
        <TextField fullWidth label="Technician" name="technician" variant="outlined"
          error={formik.errors.technician && formik.touched.technician}
          helperText={formik.touched.technician ? formik.errors.technician : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.technician} />
        <TextField fullWidth label="Designation" name="designation" variant="outlined"
          error={formik.errors.designation && formik.touched.designation}
          helperText={formik.touched.designation ? formik.errors.designation : ''}
          onBlur={formik.handleBlur} onChange={formik.handleChange} value={formik.values.designation} />
      </div>


      <div style={{ display: "flex", justifyContent: "flex-end", }}>
        <Button onClick={handlep} style={{ backgroundColor: dye ? "orange" : "gray", color: "white", marginInline: "0.7rem", opacity: dye ? 1 : 0.5 }} disabled={!dye}>PRINT</Button>

        <Button
          onClick={formik.handleSubmit}
          style={{
            backgroundColor: "Green",
            color: "white",
            marginInline: "0.7rem",

          }}
        >
          {dyeId === undefined ? "Save" : "Update"}
        </Button>

        <Button onClick={handleBack} style={{ backgroundColor: "red", color: "white", marginInline: "0.7rem" }}>CANCEL</Button>
        <Button onClick={handleBack} style={{ backgroundColor: "blue", color: "white" }}>BACK</Button>

      </div>
      {/* Unpaid Bills Warning Dialog */}
      <Dialog
        open={unpaidDialogOpen}
        onClose={() => setUnpaidDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ backgroundColor: '#d32f2f', color: '#fff' }}>
          ⚠️ Unpaid Bills Alert
        </DialogTitle>

        <div style={{ padding: '1rem' }}>
          <p style={{ color: '#d32f2f', fontWeight: 600, marginBottom: '1rem' }}>
            This customer has the following unpaid bills pending for more than 90 days.
            Please close these bills before creating a new transaction.
          </p>

          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: '#1976d2', color: '#fff' }}>
                <th style={thStyle}>#</th>
                <th style={thStyle}>Bill No</th>
                <th style={thStyle}>Bill Date</th>
                <th style={thStyle}>Total Amount (₹)</th>
                <th style={thStyle}>Received (₹)</th>
                <th style={thStyle}>Balance (₹)</th>
                <th style={thStyle}>Days Pending</th>
              </tr>
            </thead>
            <tbody>
              {unpaidBills.map((bill, i) => (
                <tr key={bill.id} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f5f5f5' }}>
                  <td style={tdStyle}>{i + 1}</td>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{bill.Bill_no}</td>
                  <td style={tdStyle}>{bill.Bill_Date}</td>
                  <td style={tdStyle}>₹{Number(bill.GrandTotalAmt).toFixed(2)}</td>
                  <td style={tdStyle}>₹{Number(bill.received_amount).toFixed(2)}</td>
                  <td style={{ ...tdStyle, color: '#d32f2f', fontWeight: 700 }}>
                    ₹{Number(bill.balance).toFixed(2)}
                  </td>
                  <td style={{ ...tdStyle, color: '#d32f2f', fontWeight: 700 }}>
                    {bill.days_pending} days
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <DialogActions>
          <Button
            onClick={() => setUnpaidDialogOpen(false)}
            variant="contained"
            color="error"
          >
            OK, I Understand
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openPDFModal}
        onClose={handlePDFModalClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

        maxWidth={1200}
      >
        <DialogTitle>
          Invoice
        </DialogTitle>

        <iframe title="pdf-view" src={pdfData && pdfData ? `${APP_BASE_PATH}${pdfData}` : null} width="800px" height="800px"></iframe>

        <DialogActions>
          <Button onClick={handlePDFModalClose}>Close</Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={isConfirmationOpen}
        message={confirmationMessage}
        color={color}
        onClose={() => setIsConfirmationOpen(false)}
      />
    </div>

  )
}

export default CreateDyes;
